import { authRoles } from "auth/authRoles";
import { AuthTabPanel, MerchantRaisedDisputeList } from "components/tabs/dispute";
import { Log } from "./Log";
import { AdminLog, FraudManagement, RequestLogs } from "./pages";
import ActivityLog from "./pages/activity/activity-log";

const LogRoutes = [
  {
    path: "/logs",
    element: <Log />,
    auth: authRoles.admin,
    children: [
      {
        path: "admin-logs",
        element: <AdminLog />,
      },
      {
        path: "fraud-management",
        element: <FraudManagement />,
        children: [
          {
            path: "fraud_rules",
            element: <AuthTabPanel />,
          },
          {
            path: "fraud_events",
            element: <MerchantRaisedDisputeList />,
          },
        ],
      },
      {
        path: "requests",
        element: <RequestLogs />,
      },
      {
        path: "activity",
        element: <ActivityLog />,
      },
    ],
  },
];

export default LogRoutes;
